export const setDefaultProductImg = (e)=> {
  if (e.currentTarget) {
    e.currentTarget.src = process.env.REACT_APP_END_POINT + '/images/default-product-img.png';
  } else {
    e.src = process.env.REACT_APP_END_POINT + '/images/default-product-img.png';
  }
};
